import React from 'react';
import PortButton from '../PortButton';
import { enhancedTheme } from '../utils';

const GenericDevice = ({
  ports,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
  label = 'Device',
}) => (
  <div style={{ width: '100%' }}>
    <div style={{ fontSize: 11, color: enhancedTheme.sectionLabel, marginBottom: 6 }}>
      {label}
    </div>
    {ports.length > 0 ? (
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {ports.map((port, i) => (
          <PortButton
            key={port._id}
            port={port}
            slotNumber={i + 1}
            selected={String(selectedPortId) === String(port._id)}
            connected={connectedPortIds.has(String(port._id))}
            onClick={onPortClick}
            onRegisterAnchor={onRegisterAnchor}
            size={16}
          />
        ))}
      </div>
    ) : (
      <div
        style={{
          height: 28,
          background: 'linear-gradient(180deg, #f5f5f5 0%, #e8e8e8 100%)',
          border: '1px solid #d9d9d9',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          color: '#8c8c8c',
        }}
      >
        Equipment placeholder — link Device Registry for port details
      </div>
    )}
  </div>
);

export default GenericDevice;
